// cspell:disable
import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type LocationId = ID<"location">;
export const locationIdFormat = idFormat<LocationId>({ prefix: "loc_" });

export type LocationInventoryId = ID<"locationInventory">;
export const locationInventoryIdFormat = idFormat<LocationInventoryId>({
  prefix: "li_",
});

export type ReservedInventoryBucketId = ID<"reservedInventoryBucket">;
export const reservedInventoryBucketIdFormat =
  idFormat<ReservedInventoryBucketId>({ prefix: "rib_" });

export type CustomReservedInventoryBucketTypeId =
  ID<"customReservedInventoryBucketType">;
export const customReservedInventoryBucketTypeIdFormat =
  idFormat<CustomReservedInventoryBucketTypeId>({ prefix: "cribt_" });

export type InventoryAdjustmentReasonId = ID<"inventoryAdjustmentReason">;
export const inventoryAdjustmentReasonIdFormat =
  idFormat<InventoryAdjustmentReasonId>({ prefix: "iar_" });

export type AdjustmentSessionId = ID<"inventoryAdjustmentSession">;
export const adjustmentSessionIdFormat = idFormat<AdjustmentSessionId>({
  prefix: "adj_",
});

export type CycleCountRuleId = ID<"cycleCountRule">;
export const cycleCountRuleIdFormat = idFormat<CycleCountRuleId>({
  prefix: "ccr_",
});

export type CycleCountId = ID<"cycleCount">;
export const cycleCountIdFormat = idFormat<CycleCountId>({ prefix: "cyc_" });

export type CycleCountLineId = ID<"cycleCountLine">;
export const cycleCountLineIdFormat = idFormat<CycleCountLineId>({
  prefix: "ccl_",
});

export type ForecastId = ID<"forecast">;
export const forecastIdFormat = idFormat<ForecastId>({ prefix: "fcst_" });

export type SupplierId = ID<"supplier">;
export const supplierIdFormat = idFormat<SupplierId>({ prefix: "sup_" });

export type SupplierContactId = ID<"supplierContact">;
export const supplierContactIdFormat = idFormat<SupplierContactId>({
  prefix: "supc_",
});

export type SupplierProductId = ID<"supplierProduct">;
export const supplierProductIdFormat = idFormat<SupplierProductId>({
  prefix: "spr_",
});

export type PurchaseOrderId = ID<"purchaseOrder">;
export const purchaseOrderIdFormat = idFormat<PurchaseOrderId>({
  prefix: "po_",
});

export type PurchaseOrderRecommendationId = ID<"purchaseOrderRecommendation">;
export const purchaseOrderRecommendationIdFormat =
  idFormat<PurchaseOrderRecommendationId>({ prefix: "por_" });

export type PurchaseOrderRecommendationRuleId =
  ID<"purchaseOrderRecommendationRule">;
export const purchaseOrderRecommendationRuleIdFormat =
  idFormat<PurchaseOrderRecommendationRuleId>({ prefix: "porr_" });

export type PurchaseOrderProductId = ID<"purchaseOrderProduct">;
export const purchaseOrderProductIdFormat = idFormat<PurchaseOrderProductId>({
  prefix: "pop_",
});

export type InboundShipmentId = ID<"inboundShipment">;
export const inboundShipmentIdFormat = idFormat<InboundShipmentId>({
  prefix: "inb_",
});

export type PurchaseOrderFileId = ID<"purchaseOrderFile">;
export const purchaseOrderFileIdFormat = idFormat<PurchaseOrderFileId>({
  prefix: "pof_",
});

export type PoUploadJobId = ID<"poUploadJob">;
export const poUploadJobIdFormat = idFormat<PoUploadJobId>({ prefix: "puj_" });

export type PoUploadJobFileId = ID<"poUploadJobFile">;
export const poUploadJobFileIdFormat = idFormat<PoUploadJobFileId>({
  prefix: "puf_",
});

export type HsCodeId = ID<"hsCode">;
export const hsCodeIdFormat = idFormat<HsCodeId>({ prefix: "hsc_" });

export type InboundShipmentProductId = ID<"inboundShipmentProduct">;
export const inboundShipmentProductIdFormat =
  idFormat<InboundShipmentProductId>({ prefix: "isp_" });

export type InboundShipmentFileId = ID<"inboundShipmentFile">;
export const inboundShipmentFileIdFormat = idFormat<InboundShipmentFileId>({
  prefix: "isf_",
});

export type ShipmentDisputeId = ID<"shipmentDispute">;
export const shipmentDisputeIdFormat = idFormat<ShipmentDisputeId>({
  prefix: "shd_",
});

export type ShipmentDisputePhotoId = ID<"shipmentDisputePhoto">;
export const shipmentDisputePhotoIdFormat = idFormat<ShipmentDisputePhotoId>({
  prefix: "sdp_",
});

export type TransferOrderId = ID<"transferOrder">;
export const transferOrderIdFormat = idFormat<TransferOrderId>({
  prefix: "trn_",
});

export type TransferOrderProductId = ID<"transferOrderProduct">;
export const transferOrderProductIdFormat = idFormat<TransferOrderProductId>({
  prefix: "trp_",
});

export type TransferOrderFileId = ID<"transferOrderFile">;
export const transferOrderFileIdFormat = idFormat<TransferOrderFileId>({
  prefix: "trf_",
});

export type InventoryItemId = ID<"inventoryItem">;
export const inventoryItemIdFormat = idFormat<InventoryItemId>({
  prefix: "ii_",
});
